import { Injectable } from '@angular/core';
import { MfeUtilsService } from './mfe-utils.abstract.service';
import { AppNavigationItem } from './shell-mfe-utils.service';

@Injectable()
export class StandaloneMfeUtilsService extends MfeUtilsService {
  readonly appName = 'referrals';
  readonly isMfe = false;
  publishMenu(): void {}
  addMenuItemWithChildrenToNav(item: AppNavigationItem): void {}
  addMenuItemToNav(id: string, label: string, icon: string, stateName: string, stateParams?: Record<string, unknown>) {}
  disableMenuItems(): void {}
  enableMenuItems(): void {}
}
